import React, { useState,} from "react";
import TeacherSidebar from "../../common/Sidebar/TeacherSidebar";
import "../TeacherLiveClass/liveClasses.css";

// import firebase from "../../../firebase";
//var storageRef = firebase.storage().ref();
// var videos = [
//     {
//       title: "Quantum Mechanic",
//       thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//       description: "Difficult",
//       time: "Sat 5:30 pm, 22 Jan, 2022",
//       subject:"Physics"
//     },
//     {
//       title: "Quantum Mechanic",
//       thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//       description: "Difficult",
//       time: "Sat 5:30 pm, 22 Jan, 2022",
//       subject: "Physics"
//     },
//     {
//       title: "Quantum Mechanic",
//       thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//       description: "Difficult",
//       time: "Sat 5:30 pm, 22 Jan, 2022",
//       subject: "Physics"
//     },{
//       title: "Quantum Mechanic",
//       thumbnail: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
//       description: "Difficult",
//       time: "Sat 5:30 pm, 22 Jan, 2022",
//       subject: "Physics"
//     },
//   ]
// const toBlob = (file) => {
//   return new Blob([file], {
//     type: "video/mp4",
//   });
// };
// var metadata = {
//   contentType: "video/mp4",
// };
const LiveClassSchedule = ({ educator }) => {
  //const [selectedFile, setSelectedFile] = useState(null);
  //const [data, setData] = useState("");
  const [classData, setClassData] = useState({
    title: "",
    desc: "",
    view: "",
    subject: "",
    date: "",
    time: "",
    thumbnail: "",
  });
  // function onFile(e){
  //   e.preventDefault();
  //   console.log(e.target.files[0]);
  //   setSelectedFile(e.target.files[0]);
  // }
  // async function onFileUpload(e) {
  //   e.preventDefault();
  //   const formData = new FormData();
  //   if (selectedFile == null) {
  //     alert("No file Selected!!!");
  //   } else {
  //     formData.append(
  //       "myFile",
  //       selectedFile,
  //       selectedFile.name
  //     );
  //     console.log(selectedFile);
  //     try {
  //       const blob = toBlob(selectedFile);
  //       // this.setState({ isLoading: true });
  //       console.log(blob);
  //       var mountainsRef = await storageRef.child(selectedFile.name);
  //       await mountainsRef.put(blob, metadata);
  //       const res = await mountainsRef.getDownloadURL();
  //       console.log(res);
  //       setData(res);
  //       // setTimeout(()=>{},5000);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  // }
  const handleSubmit=(e)=>{
    e.preventDefault();
    const uemail = JSON.parse(localStorage.getItem('user'));
    console.log(uemail.email);
    //const resEmail = uemail['email'];
    console.log(classData.time.toLocaleString());
    console.log(classData.date.toLocaleString())  
    fetch("https://edtechv.herokuapp.com/api/new_session",{
    method:"post",
    headers: { "Content-type": "application/json" },
    body: JSON.stringify({
      email: uemail.email,
      title:classData.title,
      time: classData.time.toLocaleString(),
      date: classData.date.toLocaleString()
    }),
  })
  .then((response) => response.json())
  .then((resp) => {
    if(resp === "Error while Creating Session"){
      alert("Wrong Submission")
    }
    else{
      console.log(resp);
      alert('video creted successfully');
      }
  });
  }
  return(
      <div>
    <div className="educator-home">
      <TeacherSidebar/>
      <div className="main-schedule">
        <h1> Add Videos </h1>
          <div className="classArea">
          <form onSubmit={handleSubmit}>
            <input
              id="standard-basic"
              name="title"
              placeholder="Title"
              value={classData.title}
              onChange={(e) =>
                setClassData({ ...classData, title: e.target.value })
              }
              label="Title"
              style={{}}
            />
            <input
              name="desc"
              id="standard-basic "
              placeholder="Desciption"
              value={classData.desc}
              onChange={(e) =>
                setClassData({ ...classData, desc: e.target.value })
              }
              label="Description"
            />

            <div className="single-line">
              <input
                name="subject"
                value={classData.subject}
                onChange={(e) =>
                  setClassData({ ...classData, subject: e.target.value })
                }
                className="single1"
                id="standard-basic"
                label="Subject"
              />
              <input
                name="Date"
                value={classData.date}
                type="date"
                onChange={(e) =>
                  setClassData({ ...classData, date: e.target.value })
                }
                className="single1"
                id="standard-basic"
                label="Date"
              />
              <input
                name="Time"
                value={classData.time}
                type="time"
                onChange={(e) =>
                  setClassData({ ...classData, time: e.target.value })
                }
                className="single1"
                id="standard-basic"
                label="Time"
              />
              {/* <TextField
                name="date"
                value={classData.date}
                onChange={(e) =>
                  setClassData({ ...classData, date: e.target.value })
                }
                type="date"
                placeholder=""
                style={{paddingTop:'20px'}}
                className="single2"
                id="standard-basic"
              
              />
              <TextField
                name="time"
                value={classData.time}
                onChange={(e) =>
                  setClassData({ ...classData, time: e.target.value })
                }
                className="single3"
                id="standard-basic"
                style={{paddingTop:'20px'}}
                type="time"
              /> */}
            </div>
            {/* <label className="thumbnail-label">Thumbnail</label> */}
            {/* <FileBase
              name="thumbnail"
              className="thumbnail"
              type="file"
              multiple={false}
              onDone={() =>
                // setClassData({ ...classData, thumbnail: base64 })
                onFile
              }
              //onChange={onFile}
              value={classData.thumbnail}
            /> */}
            {/* <input
                    type="file"
                    className="form-control"
                    id="customFile"
                    name="licensedoc"
                    onChange={onFile}
                  />
                  <label className="form-label text-light" htmlFor="customFile">
                    Upload Routine(pdf)
                  </label>
            <button className="btn btn-primary btn-sm create" style={{position: "absolute",float : "left",top: "30%"}} onClick={onFileUpload}>Upload File</button> */}
            <button className="btn btn-primary btn-sm create" type="submit">
              Create class
            </button>
          </form>
        </div>
    </div>
    </div>
    
    </div>
  );
};

export default LiveClassSchedule;
